import { Alert, Divider, Form, message, Modal, Radio, Select, SelectProps, Tag } from "antd";
import { useEffect, useState } from "react";
import { useForm } from "antd/lib/form/Form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Contexts/AuthContext";
import { BookyInput, InputType } from "../Forms/BookyInput";
import { GroupService } from "../../Services/GroupService";
import { TextService } from "../../Services/TextService";
import { MemberService } from "../../Services/MemberService";
import { WebApiCompanyDtoCompanyDto, WebApiMemberDtoMemberDto, WebApiServicesDataTransferObjectsGroupServiceGroupMemberDto, WebApiServicesDataTransferObjectsGroupServiceGroupResultDto } from "../../Repository/eventbookyapi";
import { UploadChangeParam } from "antd/lib/upload";
import { BookyButton } from "../Buttons/BookyButton";
import { MemberTable } from "../Table/MemberTable";
import { MemberPaymentStatus } from "../../Types/MemberPaymentStatus";
import { BookySelectPaymentStatus } from "../Forms/BookyPaymentStatusSelect";
import { EmailFormType } from "../../Types/EmailFormType";
import { CompanyService } from "../../Services/CompanyService";
import { BookySelectDropDown } from "../Forms/BookySelectDropDown";
import { PaymentConfiguration } from "../../Types/PaymentConfiguration";
import { EmailNotificationPreference } from "../../Types/EmailNotificationPreference";
import { CheckCircleFilled, CheckCircleOutlined } from "@ant-design/icons";
import { getCurrentYearAsOption } from "../../Helpers/PaymentYearOptions";
import { IntegrationService } from "../../Services/IntegrationService";
import { getPreviousYear } from "../../Helpers/DateHelpers";
import { getCurrentLanguage } from "../../Helpers/RouteHelper";
import { MemberFieldService } from "../../Services/MemberFieldService";
import { MembershipProductService } from "../../Services/MembershipProductService";
import { WebApiModelsMembershipProduct } from "../../Repository/eventbookyapi";
import { FilterOperator } from "../../Types/FilterOperator";

export const AddMultiplePaymentLinksForm = (props: any) => {
    const [memberFieldSettings, setMemberFieldSettings] = useState<any[]>([]);
    const [form] = useForm();
    const navigate = useNavigate();
    const [initialHtml, setInitialHtml] = useState("" as any);
    const [html, setHtml] = useState("" as any);
    const [externalEmails, setExternalEmails] = useState([] as any[]);
    const [subject, setSubject] = useState("" as string);
    const [emailIsvalid, setEmailIsValid] = useState(false as boolean);

    const [company, setCompany] = useState({} as WebApiCompanyDtoCompanyDto);

    const [loading, setLoading] = useState(false as boolean);
    const [showConfirm, setShowConfirm] = useState(false as boolean);
    const [selectedGroup, setSelectedGroup] = useState([] as number[]);
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(undefined as MemberPaymentStatus | undefined);

    const [fileResult, setFileList] = useState<UploadChangeParam>();
    const [isAllowedToSendGroupMails, setIsAllowedToSendGroupMails] = useState(true as boolean);
    const { user } = useAuth();
    const [selectedMembers, setSelectedMembers] = useState([] as WebApiMemberDtoMemberDto[]);
    const [paymentMode, setPaymentMode] = useState<"manual" | "automatic">("manual");
    const [membershipProducts, setMembershipProducts] = useState<WebApiModelsMembershipProduct[]>([]);

    const GetText = TextService.GetText;
    const hasMembershipProducts = membershipProducts.length > 0;

    useEffect(() => {
        MemberFieldService.GetMemberFields().then(setMemberFieldSettings);
        form.setFieldValue("year", getPreviousYear(0));

        if (props.groups != null && props.groups.length > 0) {
            setSelectedGroup(props.groups[0]);
            form.setFieldValue("group", props.groups[0].id)
        }

        CompanyService.GetCompany().then(company => {
            setCompany(company);
        })

        MembershipProductService.GetAllMembershipProducts().then(products => {
            setMembershipProducts(products);
        }).catch(() => { });

        GroupService.IsAllowedToSendGroupMails().then(result => {
            setIsAllowedToSendGroupMails(result.toString() === true.toString());
        });
    }, [props]);

    const onReminderFinish = async (formValues: any) => {

        if (hasNoMembersOrEmails()) {
            message.warning("Du måste skicka till minst en medlem/e-postadress.");
            return;
        }

        setShowConfirm(true);
    };

    const onFilterMembers = async () => {
        let filteredMembers: WebApiMemberDtoMemberDto[] = [];

        if (!selectedGroup.length) {
            message.warning(GetText("EmailForm_SelectOneGroup"));
        }

        filteredMembers = await MemberService.GetFilteredMembers({
            status: selectedPaymentStatus,
            emailNotificationPreference: form.getFieldValue("emailNotificationPreference") == 0 || !form.getFieldValue("emailNotificationPreference") ? EmailNotificationPreference.Unspecified : EmailNotificationPreference.NoInformationEmails,
            isAllMembers: selectedGroup.length == 0 || selectedGroup.some(p => p == -1) ? true : false,
            groupsIds: selectedGroup,
            filters: [{ fieldName: "Email", operator: FilterOperator.IsNotEmpty }]
        });

        setSelectedMembers(filteredMembers);

        if (filteredMembers.length == 0) {
            message.warning("No memebers found.")
        }
    }


    const onSendConfirmOK = async () => {
        setLoading(true);

        if (selectedMembers.length == 0) {
            message.error("Select at least one member");
            return;
        }

        var memberIds: number[] = selectedMembers.map(m => m.memberId!);

        try {
            const request: any = {
                paymentType: 1,
                memberIds: memberIds,
                connectedYear: form.getFieldValue("year").toString(),
            };

            if (paymentMode === "automatic") {
                request.generateAmountFromMembership = true;
            } else {
                request.description = form.getFieldValue("description").toString();
                request.amount = form.getFieldValue("amount");
            }

            const response = await IntegrationService.CreateMultiplePaymentLinks(request);


            if (response) {
                navigate(`/${getCurrentLanguage()}/batchJobStatus/${response}`);
            } else {
                message.success(GetText("AddMultiplePaymentLinks_LinksIsCreated"));
            }
        } catch {
            message.error(GetText("AddMultiplePaymentLinks_LinksIFailedToCreate"))
        }

        setLoading(false);
        form.setFieldValue("message", "");
        form.setFieldValue("messageFromTemplate", "");
        form.setFieldValue("subject", "");
        setShowConfirm(false);
    };

    const removeMember = (memberToRemove: WebApiServicesDataTransferObjectsGroupServiceGroupMemberDto) => {
        let newList = selectedMembers.filter(p => p.email != memberToRemove.email);
        setSelectedMembers(newList);
    };


    const groupOptions = () => {
        const options: SelectProps['options'] = [];

        props.groups.forEach((element: WebApiServicesDataTransferObjectsGroupServiceGroupResultDto) => {
            options.push({
                label: element.name,
                value: element.id,
            });
        });

        return options;
    }

    const handleGroupChange = async (value: number[]) => {
        setSelectedGroup(value);
    };

    const onSendConfirmCancel = async () => {
        setShowConfirm(false);
    };

    const onSelectPaymentChanged = async (value: MemberPaymentStatus) => {
        setSelectedPaymentStatus(value);
    };

    const onHtmlChange = (html: string) => {
        const emailContainsEmails = stringIsEmpty(subject) || htmlMessageIsEmpty(html);
        setEmailIsValid(!emailContainsEmails);
        form.setFieldValue("message", html);
        setHtml(html);
    }

    const onEmailsUpdated = async (onEmailsUpdated: any) => {
        setExternalEmails(onEmailsUpdated => ([
            ...onEmailsUpdated,
        ]));
    }

    const hasNoMembersOrEmails = () => {
        return (selectedMembers.length == 0 && externalEmails.length == 0)
    }

    const htmlMessageIsEmpty = (html: string) => {
        return html.length < 1 || html == "<p></p>"
    }

    const stringIsEmpty = (subject: string) => {
        return subject === "";
    }

    const onSubjectchange = (e: any) => {
        const emailContainsEmails = stringIsEmpty(e.target.value) || htmlMessageIsEmpty(html);
        setEmailIsValid(!emailContainsEmails);
        setSubject(e.target.value);
    }

    const onYearChanged = (value: any) => {
        form.setFieldValue("year", value);
    }

    const countMembersWithPaymentLinks = () => {
        return selectedMembers.filter(m => m.paymentLink && m.paymentLink.length > 0).length;
    }

    const countMembersWithoutPaymentLinks = () => {
        return selectedMembers.filter(m => !m.paymentLink || m.paymentLink.length === 0).length;
    }

    return <>
        <Modal
            title={GetText("AddMultiplePaymentLinks_ConfirmText")}
            open={showConfirm}
            onOk={onSendConfirmOK}
            confirmLoading={loading}
            onCancel={onSendConfirmCancel}
        >
            <p>{(GetText("AddMultiplePaymentLinks_ConfirmText1") + countMembersWithoutPaymentLinks() + GetText("AddMultiplePaymentLinks_ConfirmText2"))}</p>
        </Modal>
        {user?.hasPaidSubscription ?
            <>
                {isAllowedToSendGroupMails === true ? <Form
                    form={form}
                    layout="vertical"
                    onFinish={onReminderFinish}
                    autoComplete="off"
                >
                    <Form.Item
                    >
                    </Form.Item>

                    <h3>{!hasNoMembersOrEmails() ? <CheckCircleFilled style={{ color: "green" }} /> : <CheckCircleOutlined style={{ color: "grey" }} />} {GetText("AddMultiplePaymentLinks_Step1")}</h3>
                    <Divider style={{ marginTop: "5px" }} />
                    <span style={{ color: "red" }}>*</span> {GetText("AddMultiplePaymentLinks_ChooseReceiver")}
                    {props.type === EmailFormType.EmailFormByGroup && props.groups.length > 0 ? <><br />
                        <Select placeholder={GetText("EmailForm_ChooseCategories")} onChange={handleGroupChange} style={{ width: '400px', marginBottom: "10px" }} mode="multiple" options={groupOptions()}></Select>
                        <br /> {props.user.paymentConfiguration == PaymentConfiguration.YearlyPayments ? <BookySelectPaymentStatus showLastYearOptions={true} style={{ width: "400px" }} onSelectPaymentChanged={onSelectPaymentChanged} /> : ""}
                    </> : ""}

                    {props.type === EmailFormType.EmailFormByGroup ? <><br /><BookyButton style={{ marginTop: "10px" }} text={GetText("AddMultiplePaymentLinks_CreateSendList")} onClick={onFilterMembers}></BookyButton></> : ""}

                    {selectedMembers.length === 0 ? "" : <MemberTable user={user} isMail={true} members={selectedMembers} style={{ minWidth: '400px', marginTop: "10px" }} removeMember={removeMember} memberFieldSettings={memberFieldSettings} showPaymentLinkColumn={true} membershipProducts={membershipProducts} />}
                    {selectedMembers.length > 0 ? <><br /><i>{selectedMembers.length} {GetText("AddMultiplePaymentLinks_ChosenMembers")}</i></> : ""}

                    {selectedMembers.length > 0 && countMembersWithPaymentLinks() > 0 && <Alert
                        message={"Vissa av medlemmarna har redan betallänkar"}
                        description={`${countMembersWithPaymentLinks()} av de valda medlemmarna har redan betallänkar och kommer att hoppas över för att undvika dubbletter.`}
                        type="warning"
                        showIcon
                        style={{ marginTop: "15px", maxWidth: "600px" }}
                    />}

                    <h3 style={{ marginTop: "20px" }}>{emailIsvalid ? <CheckCircleFilled style={{ color: "green" }} /> : <CheckCircleOutlined style={{ color: "grey" }} />}  {GetText("AddMultiplePaymentLinks_Step2")}</h3>
                    <Divider style={{ margin: "5px" }} />

                    {hasMembershipProducts && (
                        <Form.Item label={GetText("AddMultiplePaymentLinks_PaymentMode")}>
                            <Radio.Group value={paymentMode} onChange={(e) => setPaymentMode(e.target.value)}>
                                <Radio value="manual">{GetText("AddMultiplePaymentLinks_ModeManual")}</Radio>
                                <Radio value="automatic">{GetText("AddMultiplePaymentLinks_ModeAutomatic")}</Radio>
                            </Radio.Group>
                        </Form.Item>
                    )}

                    {paymentMode === "manual" && (
                        <>
                            <BookyInput style={{ width: '400px' }} label={GetText("AddPayment_Description")} requiredMessage="Du måste fylla i en beskrivning för betalningen." name="description" req placeholder={"T.ex. 'Medlemsavgift 2025'"} />
                            <BookyInput type={InputType.number} label={GetText("AddPayment_NoteColumnPlaceHolder")} requiredMessage={"Du måste fylla i ett belopp."} onClick={onReminderFinish} name="amount" req placeholder={GetText("AddPayment_NoteColumnPlaceHolder")} />
                        </>
                    )}
                    <BookySelectDropDown style={{ width: '88px' }} label={GetText("AddPayment_YearColumn")} allowClear={false} name="year" handleChange={onYearChanged} options={getCurrentYearAsOption()} />
                    <Form.Item label={" "}>
                        <BookyButton
                            type="primary"
                            fullWidth={false}
                            text={"Skapa betallänkar"}
                            onClick={onReminderFinish}
                            disabled={selectedMembers.length > 0 && countMembersWithPaymentLinks() === selectedMembers.length}
                        >
                        </BookyButton>
                        {selectedMembers.length > 0 && countMembersWithPaymentLinks() === selectedMembers.length &&
                            <div style={{ color: '#ff4d4f', marginTop: '8px' }}>
                                Alla valda medlemmar har redan betallänkar. Välj andra medlemmar för att kunna skapa nya betallänkar.
                            </div>
                        }
                    </Form.Item>
                </Form> : <Alert
                    message={GetText("EmailForm_AlertSuspendedMessage")}
                    description={GetText("EmailForm_AlertSuspendedDescription")}
                    type="warning"
                />}
            </> : <span><Tag color="#1890ff">Premium</Tag><a href={"/" + getCurrentLanguage() + "/Pricing"}>{GetText("Common_UpgradeToPremium")}</a>{GetText("EmailForm_PremiumSendingMessageToGroups")}</span>
        }

    </>
}